import { useLanguage } from '@/context/LanguageContext';
import { TID } from '@/lib/testIds';
import { scrollToId } from '@/components/site/Navbar';

const NAV_ITEMS = [
  { id: 'home', key: 'home' },
  { id: 'capabilities', key: 'capabilities' },
  { id: 'research', key: 'research' },
  { id: 'partnerships', key: 'partnerships' },
  { id: 'contact', key: 'contact' },
];

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TID.footer.root}
      className="relative bg-[#0A1128] text-white border-t border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-lines opacity-40 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center border border-white/20">
                <span className="font-display font-black text-white text-sm tracking-tighter">C</span>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-display font-black text-white text-base tracking-tight uppercase">CDPA Systems Concept</span>
                <span className="font-mono text-[10px] tracking-[0.25em] text-[#94A3B8] uppercase mt-1">SRL · {t.footer.country}</span>
              </div>
            </div>
            <p className="mt-6 text-sm text-[#94A3B8] max-w-md leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#4F6355]">
              {t.footer.menu}
            </div>
            <ul className="mt-5 flex flex-col gap-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToId(item.id)}
                    className="text-sm text-[#94A3B8] hover:text-white transition-colors"
                  >
                    {t.nav[item.key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#4F6355]">
              {t.footer.legal}
            </div>
            <ul className="mt-5 flex flex-col gap-3 text-sm text-[#94A3B8]">
              <li>{t.footer.privacy}</li>
              <li>{t.footer.terms}</li>
              <li>EU · Romania</li>
            </ul>
          </div>
        </div>

        {/* Massive CDPA watermark */}
        <div className="mt-16 select-none overflow-hidden">
          <div className="font-display font-black tracking-tighter text-white/[0.04] text-[18vw] leading-[0.85] uppercase">
            CDPA
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-[#94A3B8]">
            © {year} CDPA SYSTEMS CONCEPT SRL. {t.footer.rights}
          </div>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#94A3B8]">
            v1.0 · Build {year}
          </div>
        </div>
      </div>
    </footer>
  );
}
